import { useServicesContext } from "@modules/core/services/services.context"
import { FeatureKeys } from "@modules/featureToggle/featureToggleTypes"
import { useObservable } from "micro-observables"

export function useFeatureToggle(featureKey: FeatureKeys): boolean {
  const { featureToggleService } = useServicesContext()
  return useObservable(featureToggleService.hasObservableFeature(featureKey))
}
